module.exports = __webpack_public_path__ + "img/Activate-Icon.a0e67dd3.svg";